import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]
  
  connect() {
    this.isSubmitting = false
  }

  submit(event) {
    // 既に送信中の場合は何もしない（二重送信防止）
    if (this.isSubmitting) {
      event.preventDefault()
      return false
    }
    
    // reCAPTCHAのレスポンスをチェック
    if (typeof grecaptcha !== 'undefined') {
      // 表示されているタブのreCAPTCHAのみをチェック
      const tabContent = this.element.closest('.tab-content')
      
      // このフォームが現在表示されているかチェック
      if (tabContent && !tabContent.classList.contains('hidden')) {
        // すべてのreCAPTCHAレスポンスをチェック
        let foundResponse = false
        const allWidgets = document.querySelectorAll('.g-recaptcha')
        
        for (let i = 0; i < allWidgets.length; i++) {
          const widget = allWidgets[i]
          // このウィジェットがこのフォーム内にあるかチェック
          if (this.element.contains(widget)) {
            const response = grecaptcha.getResponse(i)
            
            if (response) {
              foundResponse = true
              break
            }
          }
        }
        
        if (!foundResponse) {
          event.preventDefault()
          alert('reCAPTCHAの認証を完了してください。')
          return false
        }
      }
    }
    
    // 送信フラグを立てる
    this.isSubmitting = true
    
    // 送信ボタンを無効化
    const submitButton = this.element.querySelector('input[type="submit"]')
    if (submitButton) {
      submitButton.disabled = true
      submitButton.value = '送信中...'
    }
    
    // オーバーレイを表示
    this.createAndShowOverlay()
    
    // フォームの送信を許可
    return true
  }

  showLoadingOnClick(event) {
    // submitイベントが発火するので、ここでは何もしない
    // （submitイベントハンドラーで処理される）
  }

  createAndShowOverlay() {
    // 既存のオーバーレイがあれば何もしない
    const existingOverlay = document.getElementById('entry-form-overlay')
    if (existingOverlay) {
      return
    }
    
    // 新しいオーバーレイを作成
    const overlay = document.createElement('div')
    overlay.id = 'entry-form-overlay'
    overlay.className = 'fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center'
    overlay.style.zIndex = '9999'
    
    overlay.innerHTML = `
      <div class="text-center">
        <div class="mb-4">
          <div class="animate-spin rounded-full h-16 w-16 border-b-2 border-primary mx-auto"></div>
        </div>
        <p class="text-xl font-bold text-gray-700">送信中...</p>
        <p class="text-sm text-gray-500 mt-2">しばらくお待ちください</p>
      </div>
    `
    
    document.body.appendChild(overlay)
  }
}
